var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Analytes","active":""}},[_c('SampleAnalyteTable',{attrs:{"analytes":_vm.sample.analytes}})],1),_c('b-tab',{attrs:{"title":"Results"}},[_c('SampleResultTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }